/**
 * Authentication utilities
 */

/**
 * Get the JWT token from localStorage
 */
export const getAuthToken = () => {
  return localStorage.getItem('token');
};

/**
 * Get authorization headers for API requests
 */
export const getAuthHeaders = () => {
  const token = getAuthToken();
  return {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` }),
  };
};

/**
 * Check if user is authenticated
 */
export const isAuthenticated = () => {
  return !!localStorage.getItem('token') && !!localStorage.getItem('isAuthenticated');
};

/**
 * Clear authentication data
 */
export const clearAuth = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('isAuthenticated');
};

/**
 * Handle token expiration - clears auth and redirects to login
 */
export const handleTokenExpiration = () => {
  clearAuth();
  // Redirect to login page
  window.location.href = '/dashboard';
};

/**
 * Check if response indicates token expiration and handle it
 * Returns true if token was expired (and redirect was triggered)
 */
export const checkTokenExpiration = (response) => {
  if (response.status === 401 || response.status === 403) {
    handleTokenExpiration();
    return true;
  }
  return false;
};
